// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The snackbar - position it at the bottom and in the middle of the screen */
.snackbar[data-v-4689150a] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*visibility: hidden; !* Hidden by default. Visible on click *!*/
  min-width: 250px;
  /* Set a default minimum width */
  margin-left: -125px;
  /* Divide value of min-width by 2 */
  background-color: #333;
  /* Black background color */
  color: #fff;
  /* White text color */
  text-align: center;
  /* Centered text */
  border-radius: 2px;
  /* Rounded borders */
  padding: 10px 30px;
  /* Padding */
  position: fixed;
  /* Sit on top of the screen */
  z-index: 1;
  /* Add a z-index if needed */
  left: 50%;
  /* Center the snackbar */
  bottom: -30px;
  /* 30px from the bottom */
  opacity: 0;
  transition: all 0.3s ease;
  font-size: 14px;
}
.show[data-v-4689150a] {
  /*visibility: visible !important; !* Show the snackbar *!*/
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
        However, delay the fade out process for 2.5 seconds */
  /*-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;*/
  /*animation: fadein 0.5s, fadeout 0.5s 2.5s;*/
  /*-webkit-animation: fadein 0.5s;*/
  display: flex !important;
  bottom: 0;
  /* 30px from the bottom */
  opacity: 1;
}
.info[data-v-4689150a] {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff;
}
.success[data-v-4689150a] {
  color: white;
  background-color: rgba(46, 204, 113, 0.95);
  border-color: #c3e6cb;
}
.error[data-v-4689150a] {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
/* Show the snackbar when clicking on a button (class added with JavaScript) */
.hide[data-v-4689150a] {
  /*-webkit-animation: fadeout 0.5s;*/
}
/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein-4689150a {
from {
    bottom: 0;
    opacity: 0;
}
to {
    bottom: 30px;
    opacity: 1;
}
}
@keyframes fadein-4689150a {
from {
    bottom: 0;
    opacity: 0;
}
to {
    bottom: 30px;
    opacity: 1;
}
}
@-webkit-keyframes fadeout-4689150a {
from {
    bottom: 30px;
    opacity: 1;
}
to {
    bottom: 0;
    opacity: 0;
}
}
@keyframes fadeout-4689150a {
from {
    bottom: 30px;
    opacity: 1;
}
to {
    bottom: 0;
    opacity: 0;
}
}
`, "",{"version":3,"sources":["webpack://./np-snackbar.vue","webpack://./src/js/netpify/components/np-snackbar.vue"],"names":[],"mappings":"AAAA,6EAA6E;ACGzE;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EDDN,gEAAgE;ECG1D,gBAAA;EDDN,gCAAgC;ECE1B,mBAAA;EDAN,mCAAmC;ECC7B,sBAAA;EDCN,2BAA2B;ECArB,WAAA;EDEN,qBAAqB;ECDf,kBAAA;EDGN,kBAAkB;ECFZ,kBAAA;EDIN,oBAAoB;ECHd,kBAAA;EDKN,YAAY;ECJN,eAAA;EDMN,6BAA6B;ECLvB,UAAA;EDON,4BAA4B;ECNtB,SAAA;EDQN,wBAAwB;ECPlB,aAAA;EDSN,yBAAyB;ECRnB,UAAA;EACA,yBAAA;EACA,eAAA;ADUR;ACNI;EDQF,0DAA0D;EAC1D;6DAC2D;EAC3D,qDAAqD;EACrD,6CAA6C;EAC7C,kCAAkC;ECL5B,wBAAA;EACA,SAAA;EDON,yBAAyB;ECNnB,UAAA;ADQR;ACLI;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;ADOR;ACJI;EACI,YAAA;EACA,0CAAA;EACA,qBAAA;ADMR;ACHI;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;ADKR;AACA,8EAA8E;ACF1E;EDIF,mCAAmC;AACrC;AACA,+CAA+C;ACD3C;AACI;IAAM,SAAA;IAAW,UAAA;ADKvB;ACJM;IAAI,YAAA;IAAc,UAAA;ADQxB;AACF;ACNI;AACI;IAAM,SAAA;IAAW,UAAA;ADUvB;ACTM;IAAI,YAAA;IAAc,UAAA;ADaxB;AACF;ACXI;AACI;IAAM,YAAA;IAAc,UAAA;ADe1B;ACdM;IAAI,SAAA;IAAW,UAAA;ADkBrB;AACF;AChBI;AACI;IAAM,YAAA;IAAc,UAAA;ADoB1B;ACnBM;IAAI,SAAA;IAAW,UAAA;ADuBrB;AACF","sourcesContent":["/* The snackbar - position it at the bottom and in the middle of the screen */\n.snackbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /*visibility: hidden; !* Hidden by default. Visible on click *!*/\n  min-width: 250px;\n  /* Set a default minimum width */\n  margin-left: -125px;\n  /* Divide value of min-width by 2 */\n  background-color: #333;\n  /* Black background color */\n  color: #fff;\n  /* White text color */\n  text-align: center;\n  /* Centered text */\n  border-radius: 2px;\n  /* Rounded borders */\n  padding: 10px 30px;\n  /* Padding */\n  position: fixed;\n  /* Sit on top of the screen */\n  z-index: 1;\n  /* Add a z-index if needed */\n  left: 50%;\n  /* Center the snackbar */\n  bottom: -30px;\n  /* 30px from the bottom */\n  opacity: 0;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n.show {\n  /*visibility: visible !important; !* Show the snackbar *!*/\n  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.\n        However, delay the fade out process for 2.5 seconds */\n  /*-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;*/\n  /*animation: fadein 0.5s, fadeout 0.5s 2.5s;*/\n  /*-webkit-animation: fadein 0.5s;*/\n  display: flex !important;\n  bottom: 0;\n  /* 30px from the bottom */\n  opacity: 1;\n}\n.info {\n  color: #004085;\n  background-color: #cce5ff;\n  border-color: #b8daff;\n}\n.success {\n  color: white;\n  background-color: rgba(46, 204, 113, 0.95);\n  border-color: #c3e6cb;\n}\n.error {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n}\n/* Show the snackbar when clicking on a button (class added with JavaScript) */\n.hide {\n  /*-webkit-animation: fadeout 0.5s;*/\n}\n/* Animations to fade the snackbar in and out */\n@-webkit-keyframes fadein {\n  from {\n    bottom: 0;\n    opacity: 0;\n  }\n  to {\n    bottom: 30px;\n    opacity: 1;\n  }\n}\n@keyframes fadein {\n  from {\n    bottom: 0;\n    opacity: 0;\n  }\n  to {\n    bottom: 30px;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadeout {\n  from {\n    bottom: 30px;\n    opacity: 1;\n  }\n  to {\n    bottom: 0;\n    opacity: 0;\n  }\n}\n@keyframes fadeout {\n  from {\n    bottom: 30px;\n    opacity: 1;\n  }\n  to {\n    bottom: 0;\n    opacity: 0;\n  }\n}\n","\n\n    /* The snackbar - position it at the bottom and in the middle of the screen */\n    .snackbar {\n        display:flex;\n        justify-content: space-between;\n        align-items: center;\n        /*visibility: hidden; !* Hidden by default. Visible on click *!*/\n        min-width: 250px; /* Set a default minimum width */\n        margin-left: -125px; /* Divide value of min-width by 2 */\n        background-color: #333; /* Black background color */\n        color: #fff; /* White text color */\n        text-align: center; /* Centered text */\n        border-radius: 2px; /* Rounded borders */\n        padding: 10px 30px; /* Padding */\n        position: fixed; /* Sit on top of the screen */\n        z-index: 1; /* Add a z-index if needed */\n        left: 50%; /* Center the snackbar */\n        bottom: -30px; /* 30px from the bottom */\n        opacity: 0;\n        transition: all .3s ease;\n        font-size:14px;\n\n    }\n\n    .show {\n        /*visibility: visible !important; !* Show the snackbar *!*/\n\n        /* Add animation: Take 0.5 seconds to fade in and out the snackbar.\n        However, delay the fade out process for 2.5 seconds */\n        /*-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;*/\n        /*animation: fadein 0.5s, fadeout 0.5s 2.5s;*/\n        /*-webkit-animation: fadein 0.5s;*/\n        display: flex !important;\n        bottom: 0; /* 30px from the bottom */\n        opacity: 1;\n    }\n\n    .info {\n        color: #004085;\n        background-color: #cce5ff;\n        border-color: #b8daff;\n    }\n\n    .success {\n        color: white;\n        background-color: rgba(46, 204, 113, .95);\n        border-color: #c3e6cb;\n    }\n\n    .error {\n        color:#721c24;\n        background-color: #f8d7da;\n        border-color: #f5c6cb;\n    }\n\n    /* Show the snackbar when clicking on a button (class added with JavaScript) */\n    .hide {\n        /*-webkit-animation: fadeout 0.5s;*/\n    }\n\n    /* Animations to fade the snackbar in and out */\n    @-webkit-keyframes fadein {\n        from {bottom: 0; opacity: 0;}\n        to {bottom: 30px; opacity: 1;}\n    }\n\n    @keyframes fadein {\n        from {bottom: 0; opacity: 0;}\n        to {bottom: 30px; opacity: 1;}\n    }\n\n    @-webkit-keyframes fadeout {\n        from {bottom: 30px; opacity: 1;}\n        to {bottom: 0; opacity: 0;}\n    }\n\n    @keyframes fadeout {\n        from {bottom: 30px; opacity: 1;}\n        to {bottom: 0; opacity: 0;}\n    }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
